import { render } from "./PixModal.vue?vue&type=template&id=7e58d5b9"
import script from "./PixModal.vue?vue&type=script&lang=js"
export * from "./PixModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__